import React from 'react';

const IntegrationsTab = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white border rounded-lg p-6">
        <h2 className="text-xl font-bold text-gray-800 mb-2">Integrations</h2>
        <p className="text-sm text-gray-600">
          Integration ingestion has been removed from this tab.
        </p>
        <p className="text-sm text-gray-600 mt-1">
          A new integration flow will be added here soon.
        </p>
      </div>
    </div>
  );
};

export default IntegrationsTab;
